<template>
  <clients style="padding-top: 1px;"/>
</template>

<script>
import clients from "../components/clients";

export default {
  components: {clients},
};
</script>

<style scoped>

</style>